<div *ngIf="goals && goals.length">
  <div class="nq-note" *ngIf="note">
    <span class="material-icons info-icon">info</span>
    <span>{{ note }}</span>
  </div>

  <div class="card goal" *ngFor="let g of goals">
    <div class="nq">
      <div>
        <div class="goal-name">{{ g.goalName }}</div>
        <div class="goal-sub">Goal #{{ g.goalTargetId }} &middot; {{ g.dateRange }} &middot; Reviewed with you {{ g.reviewedOn }}</div>
      </div>
      <div>
        <div class="klabel">Proposed target</div>
        <div class="bignum">{{ g.target }} <span>{{ g.targetLabel }}</span></div>
        <div class="baseline">Baseline: {{ g.baseline }} &middot; Last quarter: {{ g.lastQuarter }}</div>
      </div>
      <div><span class="badge muted">&#9679; Assigned &mdash; not yet started</span></div>
    </div>
    <div class="nq-actions" *ngIf="g.resources && g.resources.length">
      <div class="klabel">Get ready</div>
      <div>
        <a class="btn ghost" href="#" *ngFor="let r of g.resources" (click)="$event.preventDefault(); openResource.emit(r)">
          <span class="material-icons">link</span> {{ r }}
        </a>
      </div>
    </div>
  </div>
</div>